import { withCdn } from "./cdn";

const publicImageContext = require.context(
  "../assets/public",
  true,
  /^(?!\.\/assets\/video\/).*\.(png|jpe?g|webp|gif|svg|avif|ico)$/i,
);

const isAbsoluteUrl = (value) => /^(?:[a-z]+:)?\/\//i.test(value);

export function publicAssetUrl(assetPath) {
  if (!assetPath || typeof assetPath !== "string") return assetPath;
  if (isAbsoluteUrl(assetPath) || assetPath.startsWith("data:")) return assetPath;

  if (assetPath.startsWith("/assets/video/")) {
    return withCdn(assetPath);
  }

  const [rawPath, query = ""] = assetPath.split("?");
  const normalizedPath = rawPath.replace(/^\/+/, "");
  const lookupPath = `./${normalizedPath}`;

  try {
    const resolvedUrl = publicImageContext(lookupPath);
    return `${resolvedUrl}${query ? `?${query}` : ""}`;
  } catch (error) {
    return assetPath;
  }
}
